import { Identifiable, Zone } from "@planzone/dto";

interface Props {
  zone: Identifiable<Zone>;
}

enum SortOptions {
  MostRecent = "zonePage.reportsPage.sortOptions.optionOne",
  Oldest = "zonePage.reportsPage.sortOptions.optionTwo",
}

export type { Props };

export { SortOptions };
